export default __webpack_public_path__ + "static/media/logo.7f2b3bdb.jpg";